import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AiAssistPanel } from './AiAssistPanel';

export function AiAssistBubble() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleToggle = () => setOpen(prev => !prev);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    window.addEventListener('toggle-ai-assist', handleToggle);
    window.addEventListener('open-ai-assist', handleOpen);
    window.addEventListener('close-ai-assist', handleClose);
    
    // Close on escape key
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('toggle-ai-assist', handleToggle);
      window.removeEventListener('open-ai-assist', handleOpen);
      window.removeEventListener('close-ai-assist', handleClose);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Hide the FAB and Panel entirely if on login page
  if (location.pathname === '/login') return null;

  return (
    <>
      {/* Backdrop overlay (desktop & mobile) */}
      {open && (
        <div 
          className="fixed inset-0 bg-slate-900/20 dark:bg-black/50 z-[60] backdrop-blur-sm transition-opacity"
          onClick={() => setOpen(false)}
          data-testid="assist-backdrop"
        />
      )}

      {/* Slide-Out Chat Panel */}
      <div
        className={`fixed top-0 right-0 h-[100dvh] w-full md:w-[400px] z-[70] bg-white dark:bg-[#0D1117] shadow-2xl border-l border-slate-200/80 dark:border-[#30363D] transform transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
        data-testid="assist-slideout-panel"
      >
        <AiAssistPanel
          onClose={() => setOpen(false)}

        />
      </div>

      {/* Bubble FAB - Hide on mobile when we implement the bottom nav bar, handle via CSS classes later */}
      <button
        onClick={() => setOpen(!open)}
        className={`fixed bottom-4 right-4 sm:right-6 z-[50] w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-200 md:flex ${
          open
            ? 'opacity-0 pointer-events-none scale-75' // Hide bubble when panel is open
            : 'bg-[#2E75B6] text-white hover:bg-[#2563a0] hover:shadow-xl hover:scale-105'
        } hidden md:flex`} // custom class to hide on mobile
        data-testid="assist-bubble"
        aria-label="AI Assistent"
      >
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456z" /></svg>
      </button>
    </>
  );
}
